(() => {
  const SELECTOR = '[data-search-results-grid]';

  const money = (value) => {
    const amount = Number.parseFloat(value);
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
      }).format(amount);
    } catch (_error) {
      return `${amount.toFixed(2)} ${currency}`;
    }
  };

  const imageUrl = (product) => {
    const source = product.featured_image?.url || product.image || '';
    if (!source) return '';
    return `${source}${source.includes('?') ? '&' : '?'}width=720`;
  };

  const productCard = (product) => {
    const article = document.createElement('article');
    article.className = 'product-card product-card--default search-fallback-product';

    const media = document.createElement('div');
    media.className = 'product-card__media';
    const mediaLink = document.createElement('a');
    mediaLink.className = 'product-card__media-link';
    mediaLink.href = product.url;
    const source = imageUrl(product);
    if (source) {
      const image = document.createElement('img');
      image.className = 'product-card__image';
      image.src = source;
      image.alt = product.featured_image?.alt || product.title || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = product.featured_image?.width || 720;
      image.height = product.featured_image?.height || 720;
      mediaLink.append(image);
    }
    media.append(mediaLink);

    const content = document.createElement('div');
    content.className = 'product-card__content';
    const heading = document.createElement('h3');
    heading.className = 'product-card__title';
    const titleLink = document.createElement('a');
    titleLink.href = product.url;
    titleLink.textContent = product.title;
    heading.append(titleLink);
    const price = document.createElement('div');
    price.className = 'price';
    const priceValue = document.createElement('span');
    priceValue.className = 'price__regular';
    priceValue.textContent = money(product.price_min || product.price);
    price.append(priceValue);
    content.append(heading, price);
    article.append(media, content);
    return article;
  };

  const enhance = async (grid) => {
    if (grid.dataset.fallbackLoaded === 'true' || grid.querySelector('.product-card')) return;
    const query = grid.dataset.searchQuery?.trim();
    if (!query) return;
    grid.dataset.fallbackLoaded = 'true';

    const status = document.createElement('p');
    status.className = 'search-fallback-status';
    status.setAttribute('role', 'status');
    status.textContent = 'Finding matching jewelry…';
    grid.prepend(status);

    try {
      const params = new URLSearchParams({ q: query });
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '10');
      params.set('resources[options][unavailable_products]', 'last');
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}search/suggest.json?${params}`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
      const payload = await response.json();
      const products = payload?.resources?.results?.products || [];
      status.remove();
      if (!products.length) return;

      const heading = document.createElement('h2');
      heading.className = 'search-fallback-heading';
      heading.textContent = 'Matching jewelry';
      grid.prepend(heading);
      const reference = heading.nextSibling;
      products.forEach((product) => grid.insertBefore(productCard(product), reference));
    } catch (_error) {
      status.remove();
    }
  };

  const init = () => document.querySelectorAll(SELECTOR).forEach(enhance);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
